import React from 'react';
import classnames from 'classnames';

interface StarsRatingProps {
  rating: number;
  tooltip?: string;
  totalReview?: number;
  className?: string;
}
/**
 * starIcon
 * @param type
 * @param key
 * @returns
 */
const starIcon = (type: 'full' | 'half' | 'empty', key: number | string = '') =>
  (
    <div className={`iconSprites iconSprites-${type}-star`} key={key} />
  );

/**
 * StarsRating
 *
 * @param param0
 * @returns
 */
const StarsRating = (props: StarsRatingProps) => {
  const { rating, totalReview, className } = props;

  const stars = [];
  let icon = 1;
  const MAX_RATING = 5;

  for (let i = 0; i < Math.floor(rating); i += 1) {
    stars.push(starIcon('full', i));
    icon += 1;
  }

  if (icon <= MAX_RATING) {
    stars.push(starIcon('half', icon));
    icon += 1;
  }

  if (icon <= MAX_RATING) {
    for (let i = icon; i <= MAX_RATING; i += 1) {
      stars.push(starIcon('empty', i));
    }
  }

  return (
    <div className={classnames('flex items-center stars__rating--wrapper', className)}>
      <div className="flex mr-xs flex-row stars__rating">
        {stars}
      </div>
      <span className="stars_rating--rating">
        {rating}
        / 5.0
        {totalReview > 0 && `(${totalReview} Ulasan)`}
      </span>
    </div>
  );
};

export default StarsRating;
